(function(){
  var node=document.getElementById('mcpc-config');
  if(!node)return;
  var cfg;
  try{cfg=JSON.parse(node.textContent||'{}')}catch(e){return}
  var previous=window.__mcPromoCrossController;
  if(previous&&typeof previous.destroy==='function')previous.destroy(true);

  function parseEnd(raw){
    raw=String(raw||'').trim();
    if(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(raw))return new Date(raw.replace(' ','T')+':00-05:00').getTime();
    var value=Date.parse(raw);
    return isNaN(value)?0:value;
  }

  var end=parseEnd(cfg.endsAt);
  if(end&&Date.now()>=end)return;

  var cart=null,busy=false,queued=false,paintFrame=0,destroyed=false,observer=null,surfaceObserver=null,surfaceTarget=null,expiryTimer=0,countdownTimer=0,phaseTimer=0;
  var pendingButton=null,pendingCount=0,pendingTimer=0,successTimer=0,successUntil=0;
  var sessionClaimed=false,previousCount=null,lastBroadcast='',checkoutBusy=false,lastPhase='';

  function rootUrl(){return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/'}
  function storageGet(key){try{return window.localStorage.getItem(key)||''}catch(e){return''}}
  function claimed(){return !cfg.asksForCode||sessionClaimed||storageGet(cfg.claimStorageKey)==='1'}
  function emit(name,extra){
    if(!cfg.tracking)return;
    var payload={event:name,micase_promo_type:cfg.type||'',micase_promo_code:cfg.code||'',micase_promo_surface:'cross_selling'};
    extra=extra||{};
    Object.keys(extra).forEach(function(key){payload[key]=extra[key]});
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('micase:promo-analytics',{detail:payload}));
  }
  function apiCount(value){return value&&typeof value.item_count==='number'?parseInt(value.item_count,10)||0:0}
  function domCount(){
    var badges=document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]');
    for(var i=0;i<badges.length;i++){
      var match=(badges[i].textContent||'').match(/\d+/);
      if(match)return parseInt(match[0],10)||0;
    }
    return 0;
  }
  function count(){
    var value=apiCount(cart);
    if(cfg.editor&&value<1)value=domCount();
    return value;
  }
  function tierData(){
    var ids=(cfg.eligibleProductIds||[]).map(String),quantity=0;
    (cart&&cart.items||[]).forEach(function(item){
      if(ids.indexOf(String(item.product_id))!==-1)quantity+=Math.max(0,parseInt(item.quantity,10)||0);
    });
    var tiers=(cfg.tiers||[]).filter(function(t){return Number(t.u)>0&&String(t.v||'').trim()}).slice().sort(function(a,b){return Number(a.u)-Number(b.u)});
    var current=null,next=null;
    tiers.forEach(function(t){if(Number(t.u)<=quantity)current=t;else if(!next)next=t});
    return{quantity:quantity,tiers:tiers,current:current,next:next,missing:next?Number(next.u)-quantity:0,top:!!current&&!next,known:cfg.eligibleCoverageComplete!==false};
  }
  function tierText(value,data){
    return String(value||'').split('{cantidad}').join(String(data.quantity)).split('{porcentaje}').join(data.current?String(data.current.v):'').split('{siguiente}').join(data.next?String(data.next.v):'').split('{faltan}').join(String(data.missing));
  }
  function tierPanel(kind,target){
    var wrap=el('aside','mcpc mcpc--tier mcpc--'+kind);
    wrap.setAttribute('data-mcpc-panel',kind);
    wrap.setAttribute('aria-live','polite');
    if(target)wrap.setAttribute('data-mcpc-target',target);
    wrap.style.setProperty('--mcpc-accent',cfg.accent||'#FF671F');
    var copy=el('div','mcpc__copy'),eyebrow=el('p','mcpc__eyebrow');
    eyebrow.appendChild(el('span','mcpc__badge',cfg.chip||'11 · 22 · 33'));
    copy.appendChild(eyebrow);
    copy.appendChild(el('h3','mcpc__title'));
    copy.appendChild(el('p','mcpc__body'));
    if(kind==='product'&&cfg.type!=='escalonada'&&cfg.showProductCountdown&&end){
      var deadline=el('div','mcpc__deadline');
      deadline.setAttribute('role','timer');
      deadline.setAttribute('aria-label',cfg.countdownAria||'Tiempo restante de la promoción');
      deadline.appendChild(el('span','mcpc__deadline-label',cfg.countdownLabel||'Termina en'));
      deadline.appendChild(el('strong','mcpc__deadline-value'));
      copy.appendChild(deadline);
    }
    wrap.appendChild(copy);
    var steps=el('ol','mcpc__tiers');
    steps.setAttribute('aria-label',cfg.tierProgressLabel||'Descuento por cantidad');
    wrap.appendChild(steps);
    var footer=el('div','mcpc__tier-footer');
    footer.appendChild(el('p','mcpc__tier-note',cfg.tierNote||''));
    var cta=el('a','mcpc__cta');
    cta.hidden=kind==='drawer';
    footer.appendChild(cta);
    wrap.appendChild(footer);
    return wrap;
  }
  function updateTier(panelNode){
    var data=tierData(),kind=panelNode.getAttribute('data-mcpc-panel');
    var title=data.current?(data.top?cfg.tierTopTitle:cfg.tierCurrentTitle):cfg.tierEmptyTitle;
    if(!data.known)title=cfg.tierEmptyTitle;
    setText(panelNode.querySelector('.mcpc__title'),tierText(title,data));
    var body=panelNode.querySelector('.mcpc__body');
    setText(body,data.known?tierText(data.next?cfg.tierNextBody:cfg.tierTopBody,data):cfg.tierNote);
    body.hidden=kind==='product'&&(!data.known||data.quantity===0);
    panelNode.setAttribute('data-mcpc-tier-quantity',String(data.quantity));
    var steps=panelNode.querySelector('.mcpc__tiers');
    if(steps.children.length!==data.tiers.length){
      steps.replaceChildren();
      data.tiers.forEach(function(t,index){var step=el('li','mcpc__tier');step.appendChild(el('strong','mcpc__tier-value',String(t.v)));step.appendChild(el('span','mcpc__tier-label',String(t.u)+(index===data.tiers.length-1&&data.tiers.length>1?'+':'')+(Number(t.u)===1?' '+cfg.tierItemOne:' '+cfg.tierItemMany)));steps.appendChild(step)});
    }
    data.tiers.forEach(function(t,i){var step=steps.children[i],active=data.known&&!!data.current&&Number(t.u)===Number(data.current.u);step.classList.toggle('is-reached',data.known&&Number(t.u)<=data.quantity);step.classList.toggle('is-current',active);if(active)step.setAttribute('aria-current','step');else step.removeAttribute('aria-current')});
    var cta=panelNode.querySelector('.mcpc__cta');
    setText(cta,!data.known||data.quantity===0?(cfg.cta||'Armar mi combo'):tierText(data.next?cfg.tierNextCta:cfg.tierTopCta,data));
    cta.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/pages/cual-es-tu-xiaomi');
    cta.hidden=kind==='drawer'||(kind==='product'&&(!data.known||data.quantity===0));
  }
  function discountInfo(){
    if(cfg.type==='escalonada')return{applied:false,amount:0};
    if(!cart||!cfg.code)return{applied:false,amount:0};
    var target=String(cfg.code).toLowerCase(),applied=false,lineAmount=0,cartAmount=0,itemAmount=0;
    function matches(application){return String(application&&(application.title||application.code||application.description)||'').toLowerCase().indexOf(target)!==-1}
    (cart.cart_level_discount_applications||[]).forEach(function(application){
      if(!matches(application))return;
      applied=true;
      cartAmount+=Number(application.total_allocated_amount||application.amount)||0;
    });
    (cart.items||[]).forEach(function(item){
      (item.line_level_discount_allocations||[]).forEach(function(allocation){
        if(!allocation||!matches(allocation.discount_application))return;
        applied=true;
        lineAmount+=Number(allocation.amount)||0;
      });
      (item.discounts||[]).forEach(function(discount){
        if(!matches(discount))return;
        applied=true;
        itemAmount+=Number(discount.amount)||0;
      });
    });
    return{applied:applied,amount:Math.max(lineAmount,cartAmount,itemAmount)};
  }
  function discountApplied(){return discountInfo().applied}
  function effectiveClaimed(){return claimed()||discountApplied()}
  function eligibleUnitPrices(){
    var prices=[];
    (cart&&cart.items||[]).forEach(function(item){
      if(item.gift_card||item.requires_shipping===false)return;
      var price=Number(item.final_price!=null?item.final_price:item.price)||0,quantity=Math.max(0,parseInt(item.quantity,10)||0);
      for(var i=0;i<quantity;i++)prices.push(price);
    });
    return prices.sort(function(a,b){return a-b});
  }
  function savingInfo(){
    if(cfg.type!=='2x1'||!cart)return{amount:0,applied:false};
    var prices=eligibleUnitPrices(),freeCount=cfg.repeatPairs?Math.floor(prices.length/2):(prices.length>=2?1:0),estimated=0;
    for(var i=0;i<freeCount;i++)estimated+=prices[i]||0;
    var discount=discountInfo();
    return{amount:discount.applied?(discount.amount||estimated):estimated,applied:discount.applied};
  }
  function formatMoney(cents){
    var currency=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active?window.Shopify.currency.active:'COP';
    try{return new Intl.NumberFormat('es-CO',{style:'currency',currency:currency,maximumFractionDigits:0}).format((Number(cents)||0)/100)}catch(e){return'$'+Math.round((Number(cents)||0)/100).toLocaleString('es-CO')}
  }
  function replaceTokens(value,pairs,quantity){
    var label=pairs===1?'tu primer 2×1':pairs+' pares 2×1';
    var code=cfg.code||'el código promocional';
    var products=Math.max(0,parseInt(quantity,10)||0),free=cfg.repeatPairs?Math.floor(products/2):(products>=2?1:0),paid=products-free,next=products+1,nextFree=cfg.repeatPairs?Math.floor(next/2):(next>=2?1:0),nextPaid=next-nextFree;
    return String(value||'')
      .split('{pares}').join(label)
      .split('{codigo}').join(code)
      .split('{productos}').join(String(products))
      .split('{pagas}').join(String(paid))
      .split('{gratis}').join(String(free))
      .split('{siguiente}').join(String(next))
      .split('{pagas_siguiente}').join(String(nextPaid));
  }
  function currentPhase(){
    if(!cfg.closingMode||!end)return null;
    var hours=(end-Date.now())/3600000;
    if(hours<=0)return null;
    if(cfg.type==='escalonada'){
      var localDay=function(time){return new Date(time-18000000).toISOString().slice(0,10)},finish=localDay(end);
      if(finish===localDay(Date.now()))return{name:'today',label:'TERMINA HOY',message:cfg.title};
      if(finish===localDay(Date.now()+86400000))return{name:'tomorrow',label:'MAÑANA TERMINA',message:cfg.title};
      if(hours<=96)return{name:'days',label:'ÚLTIMOS DÍAS',message:cfg.title};
      return null;
    }
    var today=Math.max(1,Number(cfg.closingTodayHours)||24);
    var tomorrow=Math.max(today,Number(cfg.closingTomorrowHours)||48);
    var start=Math.max(tomorrow,Number(cfg.closingStartHours)||96);
    if(hours<=today)return{name:'today',label:cfg.closingTodayLabel||'TERMINA HOY',message:cfg.closingTodayMessage||'Elige 2 productos. Paga solo 1.'};
    if(hours<=tomorrow)return{name:'tomorrow',label:cfg.closingTomorrowLabel||'MAÑANA TERMINA',message:cfg.closingTomorrowMessage||'Elige 2 productos. Paga solo 1.'};
    if(hours<=start)return{name:'days',label:cfg.closingDaysLabel||'ÚLTIMOS DÍAS',message:cfg.closingDaysMessage||'Elige 2 productos. Paga solo 1.'};
    return null;
  }
  function repeatOneCta(current){
    var phase=currentPhase(),value=phase&&phase.name==='today'&&cfg.repeatOneClosingCta?cfg.repeatOneClosingCta:(cfg.repeatOneCta||'Elegir el producto {siguiente}');
    return replaceTokens(value,current.pairs,current.quantity);
  }
  function phaseText(node,value){
    if(!node)return;
    if(!node.hasAttribute('data-mcpc-phase-original'))node.setAttribute('data-mcpc-phase-original',node.textContent||'');
    setText(node,value||node.getAttribute('data-mcpc-phase-original')||'');
  }
  function restorePhaseCopy(){
    var nodes=document.querySelectorAll('[data-mcpc-phase-original]');
    for(var i=0;i<nodes.length;i++){
      setText(nodes[i],nodes[i].getAttribute('data-mcpc-phase-original')||'');
      nodes[i].removeAttribute('data-mcpc-phase-original');
    }
    document.body.removeAttribute('data-micase-promo-phase');
    var note=document.querySelector('.mc2__repeat-note[data-mcpc-generated="true"]');
    if(note)note.remove();
  }
  function updatePhaseSurfaces(){
    var phase=currentPhase();
    if(!phase){restorePhaseCopy();lastPhase='';return}
    document.body.setAttribute('data-micase-promo-phase',phase.name);
    phaseText(document.querySelector('.mc2bar__message-primary'),phase.message);
    phaseText(document.querySelector('.mc2__capture .mc2__eyebrow'),phase.label);
    phaseText(document.querySelector('.mcprem__scope'),phase.label);
    if(cfg.type==='2x1'&&cfg.repeatPairs&&cfg.multiplePairMessage){
      var benefit=document.querySelector('.mc2__capture .mc2__benefit');
      if(benefit){
        var note=document.querySelector('.mc2__repeat-note');
        if(!note){note=el('p','mc2__repeat-note');note.setAttribute('data-mcpc-generated','true');benefit.insertAdjacentElement('afterend',note)}
        setText(note,cfg.multiplePairMessage);
      }
    }
    if(lastPhase!==phase.name){
      lastPhase=phase.name;
      document.dispatchEvent(new CustomEvent('micase:promo-phase',{detail:{phase:phase.name,label:phase.label,message:phase.message,endsAt:cfg.endsAt||''}}));
      emit('micase_promo_closing_phase',{micase_promo_phase:phase.name});
    }
  }
  function schedulePhase(){
    window.clearTimeout(phaseTimer);
    if(destroyed||!cfg.closingMode||!end)return;
    updatePhaseSurfaces();
    phaseTimer=window.setTimeout(function(){queuePaint();schedulePhase()},60000-(Date.now()%60000));
  }
  function state(){
    var quantity=count(),pairs=Math.floor(quantity/2),odd=quantity%2,stepStart=Math.max(1,quantity-(odd?0:1));
    if(cfg.type!=='2x1')return{title:cfg.title||cfg.chip||'',body:cfg.body||'',done:0,ready:false,pairs:0,quantity:quantity,stepStart:1};
    if(quantity<1)return{title:cfg.emptyTitle,body:cfg.emptyBody,done:0,ready:false,pairs:0,quantity:quantity,stepStart:1};
    if(!cfg.repeatPairs){
      if(quantity===1)return{title:cfg.oneTitle,body:cfg.oneBody,done:1,ready:false,pairs:0,quantity:quantity,stepStart:1};
      return{title:cfg.readyTitle,body:cfg.readyBody,done:2,ready:true,pairs:pairs,quantity:quantity,stepStart:1};
    }
    if(quantity===2)return{title:cfg.firstReadyTitle,body:cfg.firstReadyBody,done:2,ready:true,pairs:1,quantity:quantity,stepStart:1,firstReady:true};
    if(odd){
      if(pairs>0)return{title:cfg.repeatOneTitle,body:cfg.repeatOneBody,done:1,ready:false,pairs:pairs,quantity:quantity,stepStart:stepStart,repeatOne:true};
      return{title:cfg.oneTitle,body:cfg.oneBody,done:1,ready:false,pairs:0,quantity:quantity,stepStart:1};
    }
    return{title:cfg.repeatReadyTitle,body:cfg.repeatReadyBody,done:2,ready:true,pairs:pairs,quantity:quantity,stepStart:stepStart,repeatReady:true};
  }
  function el(tag,className,text){var element=document.createElement(tag);if(className)element.className=className;if(text)element.textContent=text;return element}
  function setText(element,value){
    if(!element)return;
    value=value==null?'':String(value);
    if(element.textContent!==value)element.textContent=value;
  }
  function surfaceTitle(current,kind){
    var value=current.title||cfg.title||'';
    if(kind==='product-end')value=current.ready?(cfg.productEndReadyTitle||'Tu 2×1 está listo'):(cfg.productEndIncompleteTitle||'Elige 1 más: llevas {siguiente} y pagas {pagas_siguiente}');
    if(kind==='drawer')value=current.ready?(cfg.drawerReadyTitle||'Tu 2×1 ya está listo'):(cfg.drawerIncompleteTitle||'Te falta 1 para tu 2×1');
    return replaceTokens(value,current.pairs,current.quantity);
  }
  function panel(kind,target){
    if(cfg.type==='escalonada')return tierPanel(kind,target);
    var wrap=el('aside','mcpc mcpc--'+kind+(cfg.type==='2x1'?'':' mcpc--generic')+(kind==='product-end'&&cfg.compactProductEnd?' mcpc--product-end-compact':''));
    wrap.setAttribute('data-mcpc-panel',kind);
    wrap.setAttribute('aria-live','polite');
    if(target)wrap.setAttribute('data-mcpc-target',target);
    wrap.style.setProperty('--mcpc-accent',cfg.accent||'#4983FF');
    var copy=el('div','mcpc__copy');
    var eyebrow=el('p','mcpc__eyebrow');
    eyebrow.appendChild(el('span','mcpc__badge',cfg.value||cfg.chip||'PROMO'));
    eyebrow.appendChild(el('span','mcpc__context','PROMOCIÓN ACTIVA'));
    copy.appendChild(eyebrow);
    var phase=el('p','mcpc__phase');
    phase.hidden=true;
    copy.appendChild(phase);
    copy.appendChild(el('h3','mcpc__title'));
    copy.appendChild(el('p','mcpc__body'));
    if((kind==='product'||kind==='product-end')&&cfg.showProductCountdown&&end){
      var deadline=el('div','mcpc__deadline');
      deadline.setAttribute('role','timer');
      deadline.setAttribute('aria-label',cfg.countdownAria||'Tiempo restante de la promoción');
      var deadlineIcon=el('span','mcpc__deadline-icon');
      deadlineIcon.setAttribute('aria-hidden','true');
      deadlineIcon.textContent='◷';
      deadline.appendChild(deadlineIcon);
      deadline.appendChild(el('span','mcpc__deadline-label',cfg.countdownLabel||'Termina en'));
      deadline.appendChild(el('strong','mcpc__deadline-value','00d · 00h · 00m · 00s'));
      copy.appendChild(deadline);
    }
    wrap.appendChild(copy);
    var action=el('div','mcpc__action');
    var steps=el('div','mcpc__steps');
    steps.setAttribute('role','progressbar');
    steps.setAttribute('aria-label','Progreso de la promoción 2×1');
    steps.setAttribute('aria-valuemin','0');
    steps.setAttribute('aria-valuemax','2');
    steps.appendChild(el('span','mcpc__step',cfg.stepOne));
    steps.appendChild(el('span','mcpc__step',cfg.stepTwo));
    action.appendChild(steps);
    var saving=el('p','mcpc__saving');
    saving.hidden=true;
    saving.appendChild(el('span','mcpc__saving-label'));
    saving.appendChild(el('strong','mcpc__saving-value'));
    action.appendChild(saving);
    var fineprint=el('p','mcpc__fineprint');
    fineprint.hidden=true;
    action.appendChild(fineprint);
    var math=el('p','mcpc__math');
    math.hidden=true;
    action.appendChild(math);
    var shipping=el('p','mcpc__shipping');
    shipping.hidden=true;
    action.appendChild(shipping);
    var links=el('div','mcpc__links');
    var primary=el('a','mcpc__cta',cfg.cta||'Ver promoción');
    links.appendChild(primary);
    var activate=el('a','mcpc__code',cfg.activateCta||'Activar promoción');
    activate.setAttribute('href','#micase-2x1');
    activate.hidden=true;
    links.appendChild(activate);
    action.appendChild(links);
    wrap.appendChild(action);
    return wrap;
  }
  function update(panelNode){
    if(cfg.type==='escalonada'){updateTier(panelNode);return}
    var current=state(),isClaimed=effectiveClaimed(),kind=panelNode.getAttribute('data-mcpc-panel');
    var hasBenefit=cfg.type==='2x1'&&current.pairs>0;
    setText(panelNode.querySelector('.mcpc__title'),surfaceTitle(current,kind));
    var bodyCopy=current.body||cfg.body||'';
    if(cfg.asksForCode&&!isClaimed)bodyCopy=String(bodyCopy).split('{codigo}').join('tu código privado');
    var bodyNode=panelNode.querySelector('.mcpc__body');
    if(bodyNode){
      bodyNode.hidden=kind==='drawer'||kind==='product-end';
      setText(bodyNode,replaceTokens(bodyCopy,current.pairs,current.quantity));
    }
    var status=cfg.type!=='2x1'?'generic':(current.repeatOne?'repeat-one':(current.firstReady?'first-ready':(current.repeatReady?'repeat-ready':(current.ready?'ready':(current.done===1?'one':'empty')))));
    panelNode.setAttribute('data-mcpc-state',status);
    panelNode.setAttribute('data-mcpc-claimed',isClaimed?'true':'false');
    panelNode.setAttribute('data-mcpc-benefit',hasBenefit?'true':'false');
    panelNode.style.setProperty('--mcpc-progress',Math.max(0,Math.min(100,current.done*50))+'%');
    var phaseNode=panelNode.querySelector('.mcpc__phase'),phase=currentPhase();
    if(phaseNode){phaseNode.hidden=!phase;if(phase)setText(phaseNode,phase.label)}
    if(phase)panelNode.setAttribute('data-mcpc-phase',phase.name);
    else panelNode.removeAttribute('data-mcpc-phase');
    var deadlineLabel=panelNode.querySelector('.mcpc__deadline-label');
    if(deadlineLabel)setText(deadlineLabel,phase&&phase.name==='today'?(cfg.countdownTodayLabel||'Termina hoy'):(cfg.countdownLabel||'Termina en'));
    var steps=panelNode.querySelectorAll('.mcpc__step');
    for(var i=0;i<steps.length;i++){
      steps[i].classList.toggle('is-done',i<current.done);
      if(cfg.repeatPairs&&count()>1)setText(steps[i],'Producto '+(current.stepStart+i));
      else setText(steps[i],i===0?cfg.stepOne:cfg.stepTwo);
    }
    var progress=panelNode.querySelector('.mcpc__steps');
    if(progress){
      progress.hidden=current.ready;
      progress.setAttribute('aria-valuenow',String(current.done));
      progress.setAttribute('aria-valuetext',current.done+' de 2 productos');
    }
    var saving=panelNode.querySelector('.mcpc__saving'),savingData=savingInfo();
    if(saving){
      var showSaving=!!cfg.showSavings&&savingData.amount>0;
      saving.hidden=!showSaving;
      saving.setAttribute('data-applied',savingData.applied?'true':'false');
      if(showSaving){
        var savingLabel=savingData.applied?(cfg.savingsAppliedLabel||'Ahorro aplicado'):(cfg.savingsEstimateLabel||'Ahorro estimado del 2×1');
        if(kind==='drawer')savingLabel=savingData.applied?(cfg.drawerSavingsAppliedLabel||'Ahorraste'):(cfg.drawerSavingsEstimateLabel||'Ahorras');
        setText(saving.querySelector('.mcpc__saving-label'),savingLabel);
        setText(saving.querySelector('.mcpc__saving-value'),formatMoney(savingData.amount));
      }
    }
    panelNode.classList.toggle('mcpc--compact-ready',current.ready);
    panelNode.classList.toggle('mcpc--repeat-ready',!!current.repeatReady);
    var context=panelNode.querySelector('.mcpc__context'),justAdded=Date.now()<successUntil;
    panelNode.classList.toggle('mcpc--just-added',justAdded);
    if(context){
      if(justAdded)setText(context,cfg.addedCta||'Añadido ✓');
      else if(cfg.type==='2x1'){
        if(current.ready&&cfg.repeatPairs)setText(context,current.pairs===1?'PAR COMPLETO':current.pairs+' PARES COMPLETOS');
        else setText(context,current.ready?'PAR COMPLETO':(current.repeatOne?'TE FALTA 1':(current.done===1?'TE FALTA 1':'EN TODA LA TIENDA')));
      }else setText(context,cfg.chip||'PROMOCIÓN ACTIVA');
    }
    var fineprint=panelNode.querySelector('.mcpc__fineprint');
    if(fineprint){
      var showNote=hasBenefit&&cfg.asksForCode;
      fineprint.hidden=!showNote;
      if(showNote)setText(fineprint,replaceTokens(isClaimed?(cfg.codeReadyNote||'Código listo: {codigo}'):(cfg.activateNote||'Activa la promoción antes de pagar'),current.pairs,current.quantity));
    }
    var math=panelNode.querySelector('.mcpc__math');
    if(math){
      var showMath=!!cfg.showBenefitMath&&cfg.type==='2x1'&&current.quantity>=2;
      math.hidden=!showMath;
      if(showMath)setText(math,replaceTokens(cfg.benefitMath||'{productos} productos · pagas {pagas} · {gratis} gratis',current.pairs,current.quantity));
    }
    var shipping=panelNode.querySelector('.mcpc__shipping');
    if(shipping){
      var showShipping=!!cfg.showShippingNote&&cfg.suppressFreeShipping&&current.quantity>0&&(kind==='drawer'||kind==='cart');
      shipping.hidden=!showShipping;
      if(showShipping)setText(shipping,cfg.shippingNote||'El envío se calcula según tu ciudad al pagar.');
    }
    var surface=panelNode.closest&&panelNode.closest('.mcxf');
    if(surface){
      surface.setAttribute('data-mcpc-state',status);
      surface.setAttribute('data-mcpc-claimed',isClaimed?'true':'false');
      surface.style.setProperty('--mcpc-accent',cfg.accent||'#4983FF');
    }
    var primary=panelNode.querySelector('.mcpc__cta'),activate=panelNode.querySelector('.mcpc__code');
    if(!primary)return;
    activate.hidden=true;
    if(cfg.type!=='2x1'){
      setText(primary,cfg.cta||'Ver promoción');
      primary.setAttribute('href',cfg.url||'/collections/all');
      return;
    }
    if(kind==='drawer'&&hasBenefit){
      if(cfg.asksForCode&&!isClaimed){
        setText(primary,cfg.activateCta||'Activar mi 2×1');
        primary.setAttribute('href','#micase-2x1');
      }else if(current.repeatOne){
        setText(primary,repeatOneCta(current));
        primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
      }else if(current.firstReady){
        setText(primary,cfg.firstReadyCta||'Sumar una tercera protección');
        primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
      }else{
        setText(primary,cfg.repeatCta||'Elegir otros 2 productos');
        primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
      }
      return;
    }
    if(current.firstReady){
      if(cfg.asksForCode&&!isClaimed){
        setText(primary,cfg.activateCta||'Activar mi 2×1');
        primary.setAttribute('href','#micase-2x1');
      }else{
        setText(primary,cfg.firstReadyCta||'Sumar una tercera protección');
        primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
      }
    }else if(current.repeatReady){
      if(cfg.asksForCode&&!isClaimed){
        setText(primary,cfg.activateCta||'Activar mi 2×1');
        primary.setAttribute('href','#micase-2x1');
      }else{
        setText(primary,cfg.repeatCta||'Elegir otros 2 productos');
        primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
      }
    }else if(current.ready){
      if(cfg.asksForCode&&!isClaimed){
        setText(primary,cfg.activateCta||'Activar mi 2×1');
        primary.setAttribute('href','#micase-2x1');
      }else{
        setText(primary,cfg.repeatCta||'Seguir comprando');
        primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
      }
    }else{
      setText(primary,current.repeatOne?repeatOneCta(current):(current.done===1?(cfg.oneCta||'Elegir mi segundo producto'):(cfg.emptyCta||'Elegir mis 2 productos')));
      primary.setAttribute('href',panelNode.getAttribute('data-mcpc-target')||cfg.url||'/collections/all');
    }
  }
  function targetFor(anchor,kind){
    if(!anchor)return'';
    if(!anchor.id){anchor.id='mcpc-products-'+kind;anchor.setAttribute('data-mcpc-generated-id','true')}
    return'#'+anchor.id;
  }
  function attach(root,host,kind,anchor){
    if(!host||host.querySelector('[data-mcpc-panel="'+kind+'"]'))return;
    if(root)root.classList.add('mcpc-surface-active');
    var panelNode=panel(kind,targetFor(anchor,kind));
    if(anchor&&anchor.parentNode)anchor.parentNode.insertBefore(panelNode,anchor);
    else host.insertBefore(panelNode,host.firstChild);
    update(panelNode);
  }
  function priceFrom(card){
    var node=card&&card.querySelector&&card.querySelector('.mccombo__p,.mcxf__p,.mcxc__p,.mcx__p');
    if(!node)return 0;
    var text=(node.textContent||'').replace(/[^0-9.,]/g,'').replace(/\.(?=\d{3})/g,'').replace(/,\d{1,2}$/,'').replace(/[^0-9]/g,'');
    var value=parseInt(text,10);
    return isNaN(value)?0:value*100;
  }
  function targetCartPrice(){
    var target=0;
    (cart&&cart.items||[]).forEach(function(item){
      var price=Number(item.final_price!=null?item.final_price:item.price)||0;
      if(price>target)target=price;
    });
    return target;
  }
  function cardIdentity(card,index){
    var input=card.querySelector&&card.querySelector('input[name="id"]');
    var title=card.querySelector&&card.querySelector('.mccombo__t,.mcxf__t,.mcxc__t,.mcx__t');
    return card.getAttribute('data-pid')||(input&&input.value)||(title&&title.textContent||'').trim()||String(index);
  }
  function restoreValueList(list,clearMetadata){
    if(!list)return;
    var cards=Array.prototype.slice.call(list.children).filter(function(card){return card.hasAttribute('data-mcpc-original-order')});
    cards.sort(function(a,b){return Number(a.getAttribute('data-mcpc-original-order'))-Number(b.getAttribute('data-mcpc-original-order'))});
    cards.forEach(function(card){list.appendChild(card);card.classList.remove('mcpc-value-match');var badge=card.querySelector('.mcpc-value-match__label');if(badge)badge.remove();if(clearMetadata)card.removeAttribute('data-mcpc-original-order')});
    if(clearMetadata)list.removeAttribute('data-mcpc-value-signature');
  }
  function clearValueRanking(){
    var lists=document.querySelectorAll('#mccombo-list,#mcsim-list,.mcxf__lista,.mcxc__list');
    for(var i=0;i<lists.length;i++)restoreValueList(lists[i],true);
  }
  function rankList(list,selector,target,label){
    if(!list||!target)return;
    var cards=Array.prototype.slice.call(list.children).filter(function(card){return card.matches&&card.matches(selector)});
    if(!cards.length)return;
    cards.forEach(function(card,index){if(!card.hasAttribute('data-mcpc-original-order'))card.setAttribute('data-mcpc-original-order',String(index))});
    var original=cards.slice().sort(function(a,b){return Number(a.getAttribute('data-mcpc-original-order'))-Number(b.getAttribute('data-mcpc-original-order'))});
    var signature=[count(),target,label,original.map(cardIdentity).join('|')].join('::');
    if(list.getAttribute('data-mcpc-value-signature')===signature)return;
    restoreValueList(list,false);
    cards=original;
    var best=null,bestDistance=Infinity,bestPrice=0;
    cards.forEach(function(card){
      var price=priceFrom(card);if(!price)return;
      var distance=Math.abs(target-price);
      if(distance<bestDistance||(distance===bestDistance&&price>bestPrice)){best=card;bestDistance=distance;bestPrice=price}
    });
    if(best){
      best.classList.add('mcpc-value-match');
      var badge=el('span','mcpc-value-match__label',label);
      badge.setAttribute('aria-hidden','true');
      best.insertBefore(badge,best.firstChild);
      if(cfg.valueMoveFirst&&list.firstElementChild!==best)list.insertBefore(best,list.firstElementChild);
    }
    list.setAttribute('data-mcpc-value-signature',signature);
  }
  function rankRecommendations(){
    if(!cfg.valueRanking||cfg.type!=='2x1'||!cart||count()<1){clearValueRanking();return}
    var target=targetCartPrice();if(!target)return;
    var label=count()%2===1?(cfg.valueOddLabel||'Mejor para completar tu par'):(cfg.valueEvenLabel||'Buen inicio para otro par');
    rankList(document.getElementById('mccombo-list'),'.mccombo__it',target,label);
    rankList(document.getElementById('mcsim-list'),'.mccombo__it',target,label);
    rankList(document.querySelector('.mcxf__lista'),'.mcxf__it',target,label);
    rankList(document.querySelector('.mcxc__list'),'.mcxc__it',target,label);
  }
  function watchProductEnd(){
    var next=cfg.hideTeaserOnProductEnd?document.querySelector('[data-mcpc-panel="product-end"]'):null;
    if(next===surfaceTarget)return;
    if(surfaceObserver)surfaceObserver.disconnect();
    surfaceObserver=null;
    surfaceTarget=next;
    document.body.classList.remove('mcpc-promo-surface-visible');
    if(!next||!window.IntersectionObserver)return;
    surfaceObserver=new IntersectionObserver(function(entries){
      var visible=entries.some(function(entry){return entry.isIntersecting&&entry.intersectionRatio>=.12});
      document.body.classList.toggle('mcpc-promo-surface-visible',visible);
    },{threshold:[0,.12,.5]});
    surfaceObserver.observe(next);
  }
  function mountPriceCountdown(){
    if(cfg.type!=='escalonada'||!cfg.showProduct||!cfg.showProductCountdown||!end)return;
    var price=document.querySelector('product-info .product__info-container [id^="price-"]');
    if(!price)return;
    var productInfo=price.closest('product-info');
    if(!productInfo||(cfg.eligibleProductIds||[]).map(String).indexOf(String(productInfo.getAttribute('data-product-id')))===-1)return;
    var clock=document.querySelector('[data-mcpc-price-clock]');
    if(!clock){
      clock=el('div','mcpc-price-clock');
      clock.setAttribute('data-mcpc-price-clock','');
      clock.setAttribute('role','timer');
      clock.setAttribute('aria-live','off');
      clock.appendChild(el('span','mcpc-price-clock__phase'));
      var detail=el('span','mcpc-price-clock__detail');
      detail.setAttribute('aria-hidden','true');
      var units=cfg.priceClockUnits||['DÍAS','HRS','MIN','SEG'];
      ['days','hours','minutes','seconds'].forEach(function(name,index){
        var group=el('span','mcpc-price-clock__group');
        group.setAttribute('data-clock-unit',name);
        group.appendChild(el('strong','mcpc-price-clock__number'));
        group.appendChild(el('span','mcpc-price-clock__unit',units[index]));
        detail.appendChild(group);
      });
      clock.appendChild(detail);
    }
    if(price.nextElementSibling!==clock)price.insertAdjacentElement('afterend',clock);
    clock.style.setProperty('--mcpc-accent',cfg.accent||'#6CD449');
    setText(clock.querySelector('.mcpc-price-clock__phase'),cfg.priceClockLabel||'No esperes al primer golpe');
    updatePriceCountdown(clock);
  }
  function updatePriceCountdown(clock){
    if(!clock)return;
    var remaining=Math.max(0,end-Date.now()),seconds=Math.floor(remaining/1000),minutes=Math.floor(seconds/60),days=Math.floor(minutes/1440),hours=Math.floor(minutes%1440/60),mins=minutes%60,secs=seconds%60;
    ['days','hours','minutes','seconds'].forEach(function(name,index){
      var group=clock.querySelector('[data-clock-unit="'+name+'"]');
      if(!group)return;
      group.hidden=name==='days'&&days===0;
      setText(group.querySelector('.mcpc-price-clock__number'),pad([days,hours,mins,secs][index]));
    });
    clock.setAttribute('aria-label',(cfg.countdownAria||'Tiempo restante de la promoción')+': '+days+(days===1?' día, ':' días, ')+hours+(hours===1?' hora, ':' horas, ')+mins+(mins===1?' minuto, ':' minutos, ')+secs+(secs===1?' segundo':' segundos'));
  }
  function paint(){
    if(destroyed)return;
    mountPriceCountdown();
    if(cfg.showProduct){var product=document.getElementById('mccombo');if(product)attach(product,product,'product',product.querySelector('.mccombo__list'))}
    if(cfg.showProductEnd&&cfg.type!=='escalonada'){var productEnd=document.getElementById('mcsim');if(productEnd){var endInside=productEnd.querySelector('.mcsim__panel')||productEnd;attach(productEnd,endInside,'product-end',productEnd.querySelector('.mcsim__list'))}}
    if(cfg.showCart){var cartCross=document.querySelector('.mcxc');if(cartCross){var inside=cartCross.querySelector('.mcxc__in')||cartCross;attach(cartCross,inside,'cart',cartCross.querySelector('.mcxc__list'))}}
    if(cfg.showDrawer&&cfg.type!=='escalonada'){var drawer=document.querySelector('.mcxf');if(drawer)attach(drawer,drawer,'drawer',drawer.querySelector('.mcxf__carril')||drawer.firstElementChild)}
    var panels=document.querySelectorAll('[data-mcpc-panel]');
    for(var i=0;i<panels.length;i++)update(panels[i]);
    updatePhaseSurfaces();
    rankRecommendations();
    watchProductEnd();
    publishState();
  }
  function shouldRouteCheckout(){var current=state(),benefitReady=cfg.type==='2x1'?current.pairs>0:count()>0;return !!(cfg.routeDiscountAtCheckout&&cfg.asksForCode&&cfg.code&&claimed()&&!discountApplied()&&benefitReady)}
  function discountCheckoutUrl(){return rootUrl().replace(/\/?$/,'/')+'discount/'+encodeURIComponent(cfg.code)+'?redirect='+encodeURIComponent('/checkout')}
  function publishState(){
    var current=state(),isClaimed=effectiveClaimed(),saving=savingInfo(),route=shouldRouteCheckout(),benefitReady=cfg.type==='2x1'?current.pairs>0:count()>0;
    document.body.classList.toggle('mcpc-discount-route-required',!!(route&&cfg.hideAcceleratedCheckout));
    var detail={itemCount:count(),claimed:isClaimed,ready:benefitReady,pairs:current.pairs||0,promoType:cfg.type||'',code:cfg.code||'',saving:saving.amount||0,savingApplied:!!saving.applied};
    var signature=[detail.itemCount,detail.claimed,detail.ready,detail.pairs,detail.saving,detail.savingApplied].join('|');
    if(signature===lastBroadcast)return;
    lastBroadcast=signature;
    document.dispatchEvent(new CustomEvent('micase:promo-state',{detail:detail}));
  }
  function queuePaint(){
    if(destroyed||paintFrame)return;
    paintFrame=window.requestAnimationFrame(function(){paintFrame=0;paint()});
  }
  function pad(value){return String(value).padStart(2,'0')}
  function updateCountdown(){
    window.clearTimeout(countdownTimer);
    if(destroyed||!end)return;
    var remaining=end-Date.now();
    if(remaining<=0){expire();return}
    var seconds=Math.floor(remaining/1000),days=Math.floor(seconds/86400),hours=Math.floor((seconds%86400)/3600),minutes=Math.floor((seconds%3600)/60),secs=seconds%60;
    var value=(days>0?days+'d · ':'')+pad(hours)+'h · '+pad(minutes)+'m · '+pad(secs)+'s';
    var timers=document.querySelectorAll('.mcpc__deadline-value');
    for(var i=0;i<timers.length;i++)setText(timers[i],value);
    updatePriceCountdown(document.querySelector('[data-mcpc-price-clock]'));
    countdownTimer=window.setTimeout(updateCountdown,1000-(Date.now()%1000));
  }
  function acknowledge(){
    var button=pendingButton;
    pendingButton=null;
    window.clearTimeout(pendingTimer);
    successUntil=Date.now()+2600;
    queuePaint();
    window.clearTimeout(successTimer);
    successTimer=window.setTimeout(function(){successUntil=0;queuePaint()},2650);
    if(!button||!button.isConnected)return;
    var original=button.textContent||'Agregar';
    window.setTimeout(function(){
      if(destroyed||!button.isConnected)return;
      button.textContent=cfg.addedCta||'Añadido ✓';
      button.classList.add('mcpc-added');
      window.setTimeout(function(){if(button.isConnected){button.textContent=original;button.classList.remove('mcpc-added')}},2200);
    },120);
  }
  function acceptCart(value){
    if(destroyed||!value)return;
    var next=apiCount(value),before=previousCount;
    cart=value;
    if(pendingButton&&next>pendingCount)acknowledge();
    if(before!==null&&next>before){
      emit('micase_promo_product_added',{micase_cart_quantity:next,micase_added_quantity:next-before});
      if(before===0)emit('micase_promo_first_product',{micase_cart_quantity:next});
      if(cfg.type==='2x1'&&Math.floor(next/2)>Math.floor(before/2))emit('micase_promo_pair_complete',{micase_cart_quantity:next,micase_completed_pairs:Math.floor(next/2)});
    }
    previousCount=next;
    queuePaint();
  }
  function refresh(){
    if(destroyed)return;
    if(end&&Date.now()>=end){expire();return}
    if(busy){queued=true;return}
    busy=true;
    fetch(rootUrl()+'cart.js',{headers:{Accept:'application/json'}}).then(function(response){if(!response.ok)throw new Error('cart');return response.json()}).then(acceptCart).catch(function(){queuePaint()}).then(function(){busy=false;if(queued){queued=false;refresh()}});
  }
  function cleanup(){
    var priceClocks=document.querySelectorAll('[data-mcpc-price-clock]');
    for(var n=0;n<priceClocks.length;n++)priceClocks[n].remove();
    clearValueRanking();
    restorePhaseCopy();
    document.body.classList.remove('mcpc-promo-active');
    document.body.classList.remove('mcpc-tier-active');
    document.body.classList.remove('mcpc-shipping-suppressed');
    document.body.classList.remove('mcpc-promo-preview');
    document.body.classList.remove('mcpc-discount-route-required');
    document.body.classList.remove('mcpc-promo-surface-visible');
    var panels=document.querySelectorAll('[data-mcpc-panel]');
    for(var i=0;i<panels.length;i++)panels[i].remove();
    var surfaces=document.querySelectorAll('.mcpc-surface-active');
    for(var j=0;j<surfaces.length;j++){
      surfaces[j].classList.remove('mcpc-surface-active');
      surfaces[j].removeAttribute('data-mcpc-state');
      surfaces[j].removeAttribute('data-mcpc-claimed');
      surfaces[j].style.removeProperty('--mcpc-accent');
    }
    var targets=document.querySelectorAll('[data-mcpc-generated-id="true"]');
    for(var k=0;k<targets.length;k++){targets[k].removeAttribute('id');targets[k].removeAttribute('data-mcpc-generated-id')}
  }
  function handleSubmit(event){
    var submitter=event.submitter,checkout=submitter&&submitter.matches&&submitter.matches('button[name="checkout"],input[name="checkout"],[data-checkout-button],.cart__checkout-button');
    if(checkout&&shouldRouteCheckout()){
      event.preventDefault();
      event.stopImmediatePropagation();
      routeCheckout('form');
      return;
    }
    if(!event.target||!event.target.matches||!event.target.matches('.mccombo__f,.mcxf__f,.mcx__f'))return;
    pendingButton=event.target.querySelector('button[type="submit"],button');
    pendingCount=count();
    emit('micase_promo_recommendation_add',{micase_promo_surface:event.target.matches('.mcxf__f')?'drawer':'cross_selling',micase_cart_quantity:pendingCount});
    window.clearTimeout(pendingTimer);
    pendingTimer=window.setTimeout(function(){pendingButton=null},3000);
    window.setTimeout(refresh,650);
  }
  function routeCheckout(source){
    if(checkoutBusy)return;
    checkoutBusy=true;
    emit('micase_promo_checkout_with_code',{micase_promo_surface:source||'checkout',micase_cart_quantity:count(),micase_completed_pairs:state().pairs||0});
    window.location.assign(discountCheckoutUrl());
  }
  function handleClick(event){
    var promoCta=event.target&&event.target.closest&&event.target.closest('[data-mcpc-panel] .mcpc__cta');
    if(promoCta){
      var promoPanel=promoCta.closest('[data-mcpc-panel]');
      emit('micase_promo_cross_cta',{micase_promo_surface:promoPanel&&promoPanel.getAttribute('data-mcpc-panel')||'cross_selling',micase_promo_state:promoPanel&&promoPanel.getAttribute('data-mcpc-state')||'',micase_cart_quantity:count()});
    }
    var target=event.target&&event.target.closest&&event.target.closest('button[name="checkout"],input[name="checkout"],[data-checkout-button],.cart__checkout-button,a[href="/checkout"],a[href^="/checkout?"]');
    if(!target||!shouldRouteCheckout())return;
    event.preventDefault();
    event.stopImmediatePropagation();
    routeCheckout('button');
  }
  function handleClaim(event){
    if(!event.detail||event.detail.key!==cfg.claimStorageKey)return;
    sessionClaimed=true;
    queuePaint();
  }
  function handleStorage(event){if(event.key===cfg.claimStorageKey)queuePaint()}
  function handleSectionLoad(){queuePaint()}
  function handleSectionUnload(event){
    if(!event.detail||String(event.detail.sectionId)!==String(cfg.sectionId))return;
    destroy(true);
    if(window.__mcPromoCrossController===controller)delete window.__mcPromoCrossController;
  }
  function handlePageShow(){if(end&&Date.now()>=end)expire();else refresh()}
  function handleDomMutations(records){
    queuePaint();
    if(cfg.type!=='escalonada')return;
    for(var i=0;i<records.length;i++){
      var target=records[i].target;
      if(target&&target.matches&&target.matches('#mccart [data-mc-panel]')){
        refresh();
        return;
      }
    }
  }
  function destroy(removeUi){
    if(destroyed)return;
    destroyed=true;
    if(observer)observer.disconnect();
    if(surfaceObserver)surfaceObserver.disconnect();
    if(paintFrame)window.cancelAnimationFrame(paintFrame);
    window.clearTimeout(expiryTimer);
    window.clearTimeout(countdownTimer);
    window.clearTimeout(phaseTimer);
    window.clearTimeout(successTimer);
    window.clearTimeout(pendingTimer);
    document.removeEventListener('submit',handleSubmit,true);
    document.removeEventListener('click',handleClick,true);
    document.removeEventListener('micase:promo-claimed',handleClaim);
    document.removeEventListener('cart:updated',refresh);
    document.removeEventListener('micase:cart-updated',refresh);
    document.removeEventListener('shopify:section:load',handleSectionLoad);
    document.removeEventListener('shopify:section:unload',handleSectionUnload);
    window.removeEventListener('storage',handleStorage);
    window.removeEventListener('pageshow',handlePageShow);
    if(removeUi)cleanup();
  }
  function expire(){
    destroy(true);
    if(window.__mcPromoCrossController===controller)delete window.__mcPromoCrossController;
  }
  function scheduleExpiry(){
    if(!end||destroyed)return;
    var remaining=end-Date.now();
    if(remaining<=0){expire();return}
    expiryTimer=window.setTimeout(scheduleExpiry,Math.min(remaining,2147480000));
  }

  cleanup();
  document.body.classList.add('mcpc-promo-active');
  if(cfg.type==='escalonada')document.body.classList.add('mcpc-tier-active');
  if(cfg.suppressFreeShipping)document.body.classList.add('mcpc-shipping-suppressed');
  if(cfg.editor)document.body.classList.add('mcpc-promo-preview');
  observer=new MutationObserver(handleDomMutations);
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('submit',handleSubmit,true);
  document.addEventListener('click',handleClick,true);
  document.addEventListener('micase:promo-claimed',handleClaim);
  document.addEventListener('cart:updated',refresh);
  document.addEventListener('micase:cart-updated',refresh);
  document.addEventListener('shopify:section:load',handleSectionLoad);
  document.addEventListener('shopify:section:unload',handleSectionUnload);
  window.addEventListener('storage',handleStorage);
  window.addEventListener('pageshow',handlePageShow);
  if(window.MCcarrito&&typeof window.MCcarrito.on==='function')window.MCcarrito.on(acceptCart);
  var controller={refresh:refresh,destroy:destroy};
  window.__mcPromoCrossController=controller;
  scheduleExpiry();
  schedulePhase();
  refresh();
  if(cfg.showProductCountdown&&end)updateCountdown();
})();





